EmailFormTextInputView = require('./text_input_view')
GrouponValidate = require('../../../../../groupon/frontend/validate')

class EmailFormEmailInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .email_input': 'validateEmail'

  initialize: ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".email_input"
    @errorElementID = ".validateEmailInput"
    @template = {email_input_template: true}

  isInputValid: (hideErrorMsg)->
    email = @getInputHtmlElement()?.val()?.trim()
    isValidEmail = true
    if email? && email != undefined && email != ""
      isValidEmail =  GrouponValidate.email email
      if isValidEmail
        @$el.find(@errorElementID).css('display','none')
        $('.call-back-email-input').removeClass('call-back-inputs-error-border')
      else if !hideErrorMsg
        @$el.find(@errorElementID).css('display','block')
        $('.call-back-email-input').addClass('call-back-inputs-error-border')
    return isValidEmail

  validateEmail: ->
    @isInputValid(true)
    @validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      data.user_email = @readInput()

module.exports = EmailFormEmailInputView
